@if (navigationItems && initialized) {

    <div class="mt-5">

        @if (activeNavigationItem?.action == 'billingArea') {
            <bm-billing-area-details
                    [billingAreaId]="objectIdentifier.objectId">
            </bm-billing-area-details>
        }

        @if (activeNavigationItem?.action == 'billingAreaPartner') {
            <bm-billing-area-partners
                    [billingAreaId]="objectIdentifier.objectId">
            </bm-billing-area-partners>
        }

        @if (activeNavigationItem?.action == 'billingRunType') {
            <bm-billing-area-billing-run-types
                    [billingAreaId]="objectIdentifier.objectId">
            </bm-billing-area-billing-run-types>
        }

        @if (activeNavigationItem?.action == 'paymentReminderType') {
            <bm-billing-area-payment-reminder-types
                    [billingAreaId]="objectIdentifier.objectId">
            </bm-billing-area-payment-reminder-types>
        }

        <!-- TM-1000002058: Beitragsänderungs-Information (bm.PremiumChangeNoticeType) -->
        @if (activeNavigationItem?.action == 'premiumChangeNoticeType') {
            <bm-billing-area-premium-change-notice-types
                    [billingAreaId]="objectIdentifier.objectId">
            </bm-billing-area-premium-change-notice-types>
        }
    </div>

}
